import moment from "moment";
import { exchangeSpecificFloatingPointNumber } from "../exchanges";
import { getProductType } from "../../utils/utilfunction";
// import { exchangeSpecificFloatingPointNumber } from "services/exchanges";

export function stringifyNumberToIndianLocale(number, precision = 0) {
  // console.log(number)
  return number.toLocaleString("en-IN", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
}

export const compose = (...fns) => (x) => fns.reduceRight((v, f) => f(v), x);

export function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => {
    return [el, index];
  });

  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
}

export default function checkIfNan(num) {
  if (isNaN(num)) {
    return 0;
  }
  return num;
}

export function utcTimestampToTimeString(utcTimeStamp) {
  if (!utcTimeStamp) return "--:--";
  try {
    return moment.unix(new Date(utcTimeStamp)).format("HH:mm:ss");
  } catch (error) {
    return "--:--";
  }
}

export function utcTimestampToDateString(utcTimeStamp) {
  if (!utcTimeStamp) return "--:--";
  try {

    let dateString = moment.unix(new Date(Number(utcTimeStamp))).format("DD-MM-YYYY");
    // console.log(dateString,"stamp")
    return dateString || dateString.add(10, 'y').format("DD-MM-YYYY") || "--:--";
  } catch (error) {
    return "--:--";
  }
}

export function utcTimestampToDateInfoString(utcTimeStamp, spread) {
  if (!utcTimeStamp) return "--:--";
  try {
    if (spread) return moment.unix(new Date(utcTimeStamp)).format("LL");
    return moment.unix(new Date(utcTimeStamp)).format("dddd, LL");
  } catch (error) {
    return "--:--";
  }
}

export function utcTimestampToDateInfoStringForExpiryDate(utcTimeStamp, spread) {
  if (!utcTimeStamp) return "--:--";
  try {
    if (spread) return moment.unix(new Date(utcTimeStamp + 315532800 - 19800)).format("LL");
    return moment.unix(new Date(utcTimeStamp + 315532800 - 19800)).format("dddd, LL");
  } catch (error) {
    return "--:--";
  }
}

//utcTimestampToHumanReadableTime

export function utcTimestampToDateTimeString(utcTimestamp) {
  if (!utcTimestamp) return "--:--";
  try {
    return moment.unix(new Date(utcTimestamp)).format("MMM Do YYYY HH:mm:ss ");
  } catch (error) {
    return "--:--";
  }
}

export function utcTimestampToDateYearString(utcTimestamp) {
  if (!utcTimestamp) return "--:--";
  try {
    var dateString = moment.unix(utcTimestamp).format("YYYY-MM-DD");
    if (utcTimestamp == 0) {
      return "--:--";
    }
    const myDate = moment(dateString, "YYYY-MM-DD");
    const addYear10 = myDate.add(10, 'y').format("DD-MM-YYYY");
    return addYear10;
  } catch (error) {
    return "--:--";
  }
}


export const sortFunc = (arr, keyName, order) => {
  const sortedArr = arr.sort((a, b) => {
    if (a[keyName] > b[keyName]) {
      return order ? 1 : -1;
    } else if (a[keyName] < b[keyName]) {
      return order ? -1 : 1;
    } else {
      return 0;
    }
  });

  return sortedArr;
};

export const getFormattedTradeData = (tradeObj) => {
  return {
    ...tradeObj,
    exchange_time: utcTimestampToTimeString(tradeObj.exchange_time),
    trade_time: utcTimestampToTimeString(tradeObj.trade_time),
    trade_price: Number(exchangeSpecificFloatingPointNumber(tradeObj.exchange, tradeObj.trade_price))
  }
}

export const getFormattedCompletedOrderData = (completedObj) => {
  return {
    ...completedObj,
    exchange_time: completedObj.exchange_time ? utcTimestampToTimeString(completedObj.exchange_time) : "-",
    order_entry_time: completedObj.order_entry_time ? utcTimestampToTimeString(completedObj.order_entry_time) : "-",
    price: Number(exchangeSpecificFloatingPointNumber(completedObj.exchange, completedObj.price))
  }
}

export const getFormattedPositionsData = (positionObj) => {
  return {
    ...positionObj,
    mtm: Number(exchangeSpecificFloatingPointNumber(positionObj.exchange, positionObj.mtm)),
    buyAverage: Number(exchangeSpecificFloatingPointNumber(positionObj.exchange, positionObj.buyAverage)),
    sellAverage: Number(exchangeSpecificFloatingPointNumber(positionObj.exchange, positionObj.sellAverage)),
    pnl: Number(exchangeSpecificFloatingPointNumber(positionObj.exchange, positionObj.pnl)),
    actualBuyAverage: Number(exchangeSpecificFloatingPointNumber(positionObj.exchange, positionObj.actualBuyAverage)),
    actualSellAverage: Number(exchangeSpecificFloatingPointNumber(positionObj.exchange, positionObj.actualSellAverage)),
  }
}

export const getFormattedHoldingsData = (holdingObj) => {
  return {
    ...holdingObj,
    mtm: Number(exchangeSpecificFloatingPointNumber(holdingObj.exchange, holdingObj.mtm)),
    mtm_percent_change: Number(exchangeSpecificFloatingPointNumber(holdingObj.exchange, holdingObj.mtm_percent_change)),
    pnl: Number(exchangeSpecificFloatingPointNumber(holdingObj.exchange, holdingObj.pnl)),
    pnl_percent_change: Number(exchangeSpecificFloatingPointNumber(holdingObj.exchange, holdingObj.pnl_percent_change)),
  }
}

export function capitalizeString(string) {
  if (typeof string !== 'string') return string
  try {
    const strArr = string.split(" ");
    let resStr = "";
    strArr.forEach((item, idx) => {
      resStr += item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() + " ";
    });
    return resStr;
  } catch (error) {
    return '';
  }
}

/**
 * Checks if option chain should be enabled for an instrument
 * @param {Object} instrument - The instrument object containing instrument_name, have_futures, and have_options
 * @returns {boolean} - Returns true if option chain should be enabled
 */

export const shouldEnableOptionChain = (instrument) => {
  if (!instrument) return false;
  const { instrument_name, have_futures, have_options, series } = instrument;

  // For equity instruments, check both futures and options flags
  if (instrument_name === "EQ" || series === "INDICES") {
    return have_futures && have_options;
  }

  // For futures commodity instruments, don't check flags
  if (instrument_name === "FUTCOM" || instrument_name === "OPTFUT" || instrument_name === "FUTSTK" || instrument_name === "OPTSTK" || instrument_name === "FUTIDX" || instrument_name === "OPTIDX") {
    return true;
  }


  return false;
};

export const mapOrderWindowData = (data, orderSide = 'BUY',source,order_type,product_type) => {

 
  const basePayload = {
    type: orderSide,
    trading_symbol: data.trading_symbol,
    display_name: data.display_name || data.display_symbol,
    ltp: data.ltp,
    exchange: data.exchange,
    token: data.token || data.instrument_token,
    strike_price: data.strike_price,
    multiplier: data.multiplier,
    instrument_name:data.instrument_name,
    lotsize: data.lotsize || data.lot_size,
    tick_size: data.tick_size,
    execution: data.execution || 'REGULAR',
    bestBidPrice: data.bestBidPrice,
    bestAskPrice: data.bestAskPrice,
    is_modify: data.is_modify,
    exchange_order_id: data.exchange_order_id,
    oms_order_id: data.oms_order_id,
  };

  // Add optional fields if they exist
  basePayload.product = getProductType(source==="DEFAULT"?product_type:data.product,data.exchange,data.index);
  if (data.quantity) basePayload.quantity = data.quantity;
   basePayload.order_type = source === "DEFAULT" ? order_type : data.order_type;
  if (data.price) basePayload.price = data.price;
  if (data.trigger_price) basePayload.trigger_price = data.trigger_price;
  if (data.filled_quantity) basePayload.filled_quantity = data.filled_quantity;
  if (data.pending_quantity) basePayload.pending_quantity = data.pending_quantity;
  if (data.disclosed_quantity) basePayload.disclosed_quantity = data.disclosed_quantity;
  if (data.validity) basePayload.validity = data.validity;
  if (data.variety) basePayload.variety = data.variety;
  if (data.is_modify) basePayload.is_modify = data.is_modify;
  if (data.oms_order_id) basePayload.oms_order_id = data.oms_order_id;
  if (data.exchange_order_id) basePayload.exchange_order_id = data.exchange_order_id;
  if (data.instrument_name) basePayload.instrument_name = data.instrument_name;
  if (data.instrument_type) basePayload.instrument_type = data.instrument_type;
  if (data.have_futures) basePayload.have_futures = data.have_futures;
  if (data.have_options) basePayload.have_options = data.have_options;
  if (data.tradable) basePayload.tradable = data.tradable;
  if (data.series) basePayload.series = data.series;
  if (data.diplayNetQuantity) basePayload.diplayNetQuantity = data.diplayNetQuantity;


  return basePayload;
}; 